import React from 'react';

interface AccountContextType {
  unitsLocale: string;
  id: string;
  carrierName: string;
  status?: 'initialized' | 'pending' | 'active' | 'error';
  error?: string;
  isLoadingCarrierName: boolean;
  weekStartsOn: WeekStartsOn;
  driverScoreDataSet?: string;
  isBillingSetUp?: boolean;
  isIRSetUp?: boolean;
  configuredProviders?: string[];
  tms?: string;
  adfRequired?: boolean;
  isLoading: boolean;
  isDemoAccount?: boolean;
  isAccountOnBoarded: boolean;
  timezone?: string;
  isTemplateAccount: boolean;
  isDemo6: boolean;
  hasAppsEnabled: boolean;
  isV3UIEnabled: boolean;
  isTopNavMenusHidden: boolean;
  homeProductId: string | undefined;
  remindersPreferDriverCode: boolean;
  blockBasicUsersContactingSupport: boolean;
  driverAppEmbedCarrierSlug: string | undefined;
  driverAppEmbedProgramSlug: string | undefined;
  // AI Insights chat budgets (1b) — per-user monthly override map.
  aiBudgets?: { perUserOverrideUsd?: { [userId: string]: number } };
}

export const DEFAULT_ACCOUNT_CONTEXT = {
  id: 'MOCK_ACCOUNT_ID',
  unitsLocale: 'imperial',
  weekStartsOn: process.env.NODE_ENV === 'test' ? 'MON' : 'SUN',
  isLoading: process.env.NODE_ENV === 'test' ? false : true,
  status: process.env.NODE_ENV === 'test' ? 'active' : 'error',
  carrierName: process.env.NODE_ENV === 'test' ? 'testCarrierName' : 'error',
  timezone: process.env.NODE_ENV === 'test' ? 'America/Chicago' : undefined,
  isDemo6: false,
  hasAppsEnabled: false,
  isV3UIEnabled: false,
  isTopNavMenusHidden: false,
  homeProductId: undefined,
  remindersPreferDriverCode: false,
  blockBasicUsersContactingSupport: false,
  driverAppEmbedCarrierSlug: undefined,
  driverAppEmbedProgramSlug: undefined,
} as AccountContextType;

const AccountContext = React.createContext<AccountContextType>(
  DEFAULT_ACCOUNT_CONTEXT,
);

export default AccountContext;
